import { render, staticRenderFns } from "./FlashCardDetail.vue?vue&type=template&id=46ed2866&"
import script from "@/scripts/FlashCard/FlashCardDetail/index.js?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardDetail/index.js?vue&type=script&lang=js&"
import style0 from "./FlashCardDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports